<template>
  <b-form-group
    :label="label"
    :label-for="id || 'item-' + name"
    :state="getErrors() ? false : null"
    :description="hint"
  >
    <slot />
    <b-form-file
      v-model="form[name]"
      :placeholder="$t('choose_file')"
      :drop-placeholder="$t('drop_file')"
      :multiple="multiple"
      :autofocus="autofocus"
      :readonly="readonly"
      :disabled="disabled"
      @change="process($event)"
    />
    <div
      v-if="getErrors()"
      class="help-block invalid-feedback"
      v-html="getErrors()"
    />
  </b-form-group>
</template>

<script>
import { control } from '~/mixins/control'

export default {
  name: 'VFileInput',
  mixins: [control],

  props: {
    multiple: { type: Boolean, default: false }
  },

  mounted () {
    this.updateFiles()
  },

  methods: {
    getErrors () {
      let errors = ''
      if (this.form[this.name]) {
        const files = Array.from(this.form[this.name])
        Object.keys(this.form.errors.all()).filter(field => field.indexOf(this.name) === 0).forEach((field, i) => {
          const errs = this.form.errors.getAll(field)
          errs.forEach(err => {
            errors += err ? ((files[i] ? (files[i].name + ': ') : '') + err + '<br>') : ''
          })
        })
      }
      return errors
    },
    updateFiles () {
      Object.keys(this.form.errors.all()).filter(field => field.indexOf(this.name) === 0).forEach((field, i) => {
        this.form.errors.clear(field)
      })
    },
    process (event) {
      this.form[this.name] = Array.from(event.target.files)
      this.updateFiles()
    }
  }
}
</script>

<style>
.custom-file-input ~ label.custom-file-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 40px;
}

.custom-file-input ~ label.custom-file-label[data-browse]::after {
  content: '...';
}
</style>
